<ng-container #ToasterMessageContainer></ng-container>

<ng-template #DSTV2ToasterTemplate>
    <div class="reward-popup reward-popup-dark reward-popup--toaster" role="alert" aria-live="assertive"
         aria-atomic="true" style="z-index: 1000;">
        <ng-container>
            <div class="reward-popup__content">
                <!-- toast type icon -->
                <div class="reward-popup__content__icon">
                    <ng-container *ngIf="data?.type == toasterTypeEnum.Success || data?.type == toasterTypeEnum.SuccessGoToRewards">
                        <span class="svg-icon svg-success-filled"></span>
                    </ng-container>
                    <ng-container *ngIf="data?.type == toasterTypeEnum.CompletelyExpired">
                        <span class="svg-icon svg-warning-filled"></span>
                    </ng-container>
                    <ng-container *ngIf="data?.type == toasterTypeEnum.PartiallyExpired">
                        <span class="svg-icon svg-warning-filled"></span>
                    </ng-container>
                    <ng-container *ngIf="data?.type == toasterTypeEnum.Error">
                        <span class="svg-icon svg-error-filled"></span>
                    </ng-container>
                    <ng-container *ngIf="data?.type == toasterTypeEnum.Information">
                        <span class="svg-icon svg-info-filled"></span>
                    </ng-container>
                </div>
                <!-- message -->
                <div class="reward-popup__content__text" (focusout)="closeToasteronParentFocus()">
                    <ng-container *ngIf="data?.type == toasterTypeEnum.Success">
                        <span class="body-text-sm" attr.aria-label='{{data?.message}}'>{{ data?.message || data?.type }}</span>
                    </ng-container>
                    <ng-container *ngIf="data?.type == toasterTypeEnum.SuccessGoToRewards">
                        <p class="body-text-sm" attr.aria-label='{{data?.message}}'>{{ data?.message || data?.type }}
<!--                            <span class="body-text-sm link-sm" (click)="continueToasterEvent()" (keypress)="continueToasterEvent()" role="button" tabindex="0"> Get your reward</span>-->
                        </p>
                    </ng-container>
                    <ng-container *ngIf="data?.type == toasterTypeEnum.CompletelyExpired">
                        <p class="body-text-sm" attr.aria-label='{{data?.message}}'>{{ data?.message || data?.type }}
                        </p>
                    </ng-container>
                    <ng-container *ngIf="data?.type == toasterTypeEnum.PartiallyExpired">
                        <p class="body-text-sm" attr.aria-label='{{data?.message}}'>{{ data?.message || data?.type }}   
                            <span (click)="continueToasterEvent()" (keypress)="continueToasterEvent()" class="body-text-sm link-sm" aria-label="Continue? button" role="button" tabindex="0"> Continue?</span>
                        </p>
                    </ng-container>
                    <ng-container *ngIf="data?.type == toasterTypeEnum.Error">
                        <p class="body-text-sm"  attr.aria-label='{{data?.message}}' role="button" tabindex="0">{{ data?.message || data?.type }}</p>
                    </ng-container>
                    <ng-container *ngIf="data?.type == toasterTypeEnum.Information">
                        <p class="body-text-sm"  attr.aria-label='{{data?.message}}'>{{ data?.message || data?.type }}   
                            <span (click)="continueToasterEvent()" (keypress)="continueToasterEvent()"  class="body-text-sm link-sm" aria-label="Learn more button">Learn more</span>
                        </p>
                    </ng-container>
                </div>
            </div>
            <!-- close button -->
            <button id="reward-popupCloseBtn" role="button" class="reward-popup__close-btn"
                    (click)="closeToasterEvent()" (focusout)="rollBackFocusClose()"
                    (keydown)="closeToasterEventFromKey($event)" aria-label="Close toaster pop-up message">
                <span aria-hidden="true" class="svg-icon svg-close-white"></span>
            </button>
        </ng-container>
    </div>
</ng-template>
